export default __webpack_public_path__ + "static/media/toolkit-landing-hero.00e4ed92.png";